<div class="quantity-wrapper">
  <button class="btn primary-bg-color primary-text-color font-secondary quantity-decrease" #quantityDecreaseBtn
          [attr.aria-label]="'component.quantity_selector.decrease' | translate">
    <fa-icon [icon]="faMinus"></fa-icon>
  </button>
  <input
    #quantityInput
    type="text"
    min="{{minimumQuantity}}"
    [(ngModel)]="quantity"
    aria-label="Quantity"
    [textMask]="{mask: quantityMask}"
    class="form-control primary-bg-color primary-text-color text-center quantity-input"
    (input)="setQuantityValue(quantityInput.value)"
    [attr.aria-describedby]="!!describedBy ? describedBy : (showMinWarning ? 'quantity-selector-qt-error' : undefined)" (focusout)="checkValueAfterFocusOut(quantity)">
  <button class="btn primary-bg-color primary-text-color font-secondary quantity-increase" #quantityIncreaseBtn
          [attr.aria-label]="'component.quantity_selector.increase' | translate">
    <fa-icon [icon]="faPlus"></fa-icon>
  </button>
</div>
<div class="position-relative">
  <div *ngIf="showMinWarning" id="quantity-selector-qt-error"
       [@expanded]="{value: showMinWarning, params: {speed: '100ms'}}" class="alert alert-danger position-absolute min-warning"
       translate [translateParams]="{minQuantity: minimumQuantity}">component.quantity_selector.min_warning</div>
</div>